// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"bb38543a","346":"b69deec1"}[chunkId] + ".chunk.css";
};